import { initializeApp } from 'firebase/app';
import { getMessaging, isSupported } from 'firebase/messaging';

// Config publique du projet Firebase (pas un secret : la sécurité réelle vient
// des règles Firebase / de la restriction de la clé API dans la console
// Google, pas de la confidentialité de ces valeurs). Les remplir dans .env —
// voir .env.example. Ce sont les mêmes valeurs à dupliquer telles quelles
// dans public/firebase-messaging-sw.js (un service worker statique ne peut
// pas lire les variables d'environnement de l'app).
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

let messagingPromise = null;

// Certains navigateurs (Safari ancien, mode navigation privée sur certains
// mobiles) n'ont pas l'API Push — isSupported() évite un crash silencieux.
export function getFirebaseMessaging() {
  if (!firebaseConfig.apiKey) return Promise.resolve(null);

  if (!messagingPromise) {
    messagingPromise = isSupported().then((supported) => {
      if (!supported) return null;
      const app = initializeApp(firebaseConfig);
      return getMessaging(app);
    });
  }

  return messagingPromise;
}
